import React, { useRef } from "react";
import { X } from "lucide-react";

export enum ModalSize {
  sm = "sm",
  md = "md",
  lg = "lg",
  wide = "wide",
}

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  showCloseButton?: boolean;
  className?: string;
  contentClassName?: string;
  size?: ModalSize;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  showCloseButton = true,
  className = "",
  contentClassName = "",
  size = ModalSize.md,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[600] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        aria-hidden="true"
      />
      <div
        ref={modalRef}
        className={`
          relative bg-white rounded-[20px] shadow-xl z-10 flex flex-col overflow-hidden
          ${size === ModalSize.sm && "w-[550px] max-w-[95vw]"}
          ${size === ModalSize.md && "h-3/4 w-2/3"}
          ${size === ModalSize.lg && "w-full"}
          ${size === ModalSize.wide && "w-[820px] max-w-[95vw]"}
          max-h-[90dvh] modal-portrait:max-h-[96dvh] modal-short-viewport:max-h-[96dvh]
          ${className}
        `}
        role="dialog"
        aria-modal="true"
      >
        {showCloseButton && (
          <div className="absolute top-0 right-0 p-6">
            {showCloseButton && (
              <button
                onClick={onClose}
                className="
                text-gray-400 hover:text-gray-600 
                "
                aria-label="Close modal"
              >
                <X className="w-4 h-4" />
              </button>
            )}
          </div>
        )}

        <div
          className={`overflow-y-auto flex flex-col flex-1 min-h-0 ${contentClassName}`}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
